module.exports = __webpack_public_path__ + "img/engagementring@2x.e2873cb.jpg";